import {
    JUMP_TO_MEDIA,
    PREVIOUS_MEDIA,
    NEXT_MEDIA,
} from 'redux/navigation/actions'
import { INIT_AVAILABLE_FILTERS } from 'redux/availableFilters/actions'

export const availableFilters = (state = [], action) => {
    switch (action.type)
    {
        case JUMP_TO_MEDIA:
        case PREVIOUS_MEDIA:
        case NEXT_MEDIA:
        case INIT_AVAILABLE_FILTERS:
            return [...action.filters]
        default:
            return state
    }

}
